import Vue from 'vue';
import router from './router';
import store from './store';
import Agencies from './components/Agencies.vue';
import AgencyDetails from './components/AgencyDetails.vue';

Vue.config.productionTip = false;

document.querySelectorAll('.coscda-elementor').forEach(element => {
    new Vue({
        router,
        store,
        components: {Agencies, AgencyDetails},
    }).$mount(element);
});
